module.exports = __webpack_public_path__ + "712000ec0f5903081080fc095c2b61b4.jpg";